import { BaseDialog } from './__internal__';
import { jsx as _jsx } from "react/jsx-runtime";
export const Dialog = props => /*#__PURE__*/_jsx(BaseDialog, {
  ...props
});
//# sourceMappingURL=Dialog.js.map